import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function Footer() {
  const { t } = useTranslation();

  const mainSiteLinks = [
    { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
    { name: 'Hoodies/Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html' },
    { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html' },
    { name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html' },
    { name: 'Pants/Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html' },
    { name: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html' },
    { name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html' },
    { name: 'Underwear', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html' },
    { name: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html' },
    { name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html' },
    { name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html' },
    { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html' },
    { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html' },
    { name: 'Other', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html' },
  ];

  return (
    <footer className="bg-secondary-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <h3 className="text-lg font-bold text-foreground-950 mb-4">CSSBuy Spreadsheet</h3>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              {t('footer_disclaimer')}
            </p>
            <p className="text-xs text-foreground-500 italic">
              {t('disclaimer')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 uppercase tracking-wider">{t('nav_categories')}</h4>
            <div className="grid grid-cols-2 gap-2">
              {mainSiteLinks.slice(0, 8).map((link) => (
                <a
                  key={link.name}
                  href={link.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                >
                  {link.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 uppercase tracking-wider">More</h4>
            <div className="grid grid-cols-2 gap-2">
              {mainSiteLinks.slice(8).map((link) => (
                <a
                  key={link.name}
                  href={link.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                >
                  {link.name}
                </a>
              ))}
            </div>
          </div>

          {/* Info */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 uppercase tracking-wider">Info</h4>
            <div className="space-y-2">
              <Link to="/" className="block text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                {t('nav_home')}
              </Link>
              <Link to="/article/what-is-cssbuy-spreadsheet" className="block text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                {t('nav_article')}
              </Link>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="block text-sm text-foreground-600 hover:text-primary-600 transition-colors"
              >
                {t('cta_main_site')}
              </a>
              <span className="block text-sm text-foreground-500">{t('footer_privacy')}</span>
              <span className="block text-sm text-foreground-500">{t('footer_terms')}</span>
              <span className="block text-sm text-foreground-500">{t('footer_contact')}</span>
            </div>
          </div>
        </div>

        <div className="border-t border-background-200/70 mt-10 pt-6 text-center">
          <p className="text-sm text-foreground-500">
            {t('footer_copyright')}
          </p>
        </div>
      </div>
    </footer>
  );
}